export default {"src":"/_next/static/media/GS_Logo_Purple.292ae85f.svg","height":146,"width":728,"blurWidth":0,"blurHeight":0};